(function () {
  'use strict';

  function enhanceSortDropdown(select) {
    if (!select || select.dataset.vairoEnhanced === 'true') return;

    var wrapper = select.closest('.jdgm-rev-widg__sort-wrapper');
    if (!wrapper) return;

    select.dataset.vairoEnhanced = 'true';
    select.classList.add('vairo-sort-native');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'vairo-review-sort-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    var chevron = document.createElement('span');
    chevron.className = 'vairo-review-sort-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    trigger.append(label, chevron);

    var menu = document.createElement('div');
    menu.className = 'vairo-review-sort-menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    Array.prototype.forEach.call(select.options, function (option, index) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'vairo-review-sort-option';
      item.textContent = option.textContent.trim();
      item.dataset.value = option.value;
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
      item.addEventListener('click', function () {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        label.textContent = option.textContent.trim();
        Array.prototype.forEach.call(menu.children, function (child) {
          child.setAttribute('aria-selected', child === item ? 'true' : 'false');
        });
        closeMenu();
      });
      menu.appendChild(item);
    });

    function closeMenu() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      menu.hidden = isOpen;
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });

    label.textContent = select.options[select.selectedIndex].textContent.trim();
    wrapper.append(trigger, menu);
  }

  function scan() {
    document.querySelectorAll('.jdgm-rev-widg__sort-wrapper select.jdgm-sort-dropdown')
      .forEach(enhanceSortDropdown);
    document.querySelectorAll('.jdgm-rev-widg__reviews').forEach(enhanceCarousel);
  }

  function enhanceCarousel(reviews) {
    if (reviews.dataset.vairoCarousel === 'true') return;
    var cards = reviews.querySelectorAll('.jdgm-rev');
    if (cards.length < 2) return;

    var shell = reviews.parentElement;
    if (!shell) return;
    shell.classList.add('vairo-reviews-carousel-shell');
    reviews.dataset.vairoCarousel = 'true';

    var previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'vairo-review-carousel-arrow vairo-review-carousel-arrow--prev';
    previous.setAttribute('aria-label', 'Reseñas anteriores');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'vairo-review-carousel-arrow vairo-review-carousel-arrow--next';
    next.setAttribute('aria-label', 'Más reseñas');

    function updateButtons() {
      previous.disabled = reviews.scrollLeft <= 2;
      next.disabled = reviews.scrollLeft + reviews.clientWidth >= reviews.scrollWidth - 2;
    }

    function move(direction, event) {
      event.preventDefault();
      event.stopPropagation();
      reviews.scrollBy({
        left: direction * Math.max(reviews.clientWidth * 0.82, 320),
        behavior: 'smooth'
      });
    }

    previous.addEventListener('click', function (event) { move(-1, event); });
    next.addEventListener('click', function (event) { move(1, event); });
    reviews.addEventListener('scroll', updateButtons, { passive: true });
    shell.append(previous, next);
    requestAnimationFrame(updateButtons);
  }

  document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
